/** Normalize visitor ids for comparisons and keys (socket/table data can mix types or brackets). */
export function normalizeVisitorUniqueId(id) {
  if (id == null || id === "") return "";
  return String(id).replace(/[\[\]]/g, "").trim();
}

export function visitorsUniqueKeyEqual(a, b) {
  return normalizeVisitorUniqueId(a) === normalizeVisitorUniqueId(b);
}

/**
 * Collapse duplicate rows that share the same normalized unique_id (keeps best focus: zIndex 1, else last).
 * Preserves first-seen order of each id in the list.
 */
export function dedupeActiveVisitors(visitors) {
  if (!Array.isArray(visitors) || visitors.length === 0) return visitors || [];
  const buckets = new Map();
  const firstSeenOrder = [];

  for (const v of visitors) {
    const id = normalizeVisitorUniqueId(v?.unique_id);
    if (!id) continue;
    if (!buckets.has(id)) {
      firstSeenOrder.push(id);
      buckets.set(id, []);
    }
    buckets.get(id).push(v);
  }

  return firstSeenOrder.map((id) => {
    const group = buckets.get(id);
    const focused = group.find((x) => x?.zIndex === 1);
    if (focused) return focused;
    return group[group.length - 1];
  });
}
